"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var NextStep = function NextStep(_ref) {
  var step = _ref.step;
  return /*#__PURE__*/_react["default"].createElement("p", null, step);
};
NextStep.displayName = 'BackLink';
var _default = NextStep;
exports["default"] = _default;